export default __webpack_public_path__ + "static/media/drag-handler.71187505.svg";